<div class="p-24">
    <div class="row">
        <div class="col-lg-8">
            <h3 *ngIf="isEdit">{{ 'LABEL.UPDATE_LABEL' | translate }} {{ 'ENTITY.SUBCATEGORY' | translate }}</h3>
            <h3 *ngIf="!isEdit">{{ 'LABEL.ADD_LABEL' | translate }} {{ 'ENTITY.SUBCATEGORY' | translate }}</h3>
        </div>
        <div class="col-lg-4">

        </div>
    </div>

    <form [formGroup]="subCategoryForm">
        <div class="row m-t-20">
            <div class="col-lg-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'ENTITY.SUBCATEGORY' | translate }}</mat-label>
                    <input matInput placeholder="{{ 'ENTITY.SUBCATEGORY' | translate }}" formControlName="name">
                    <mat-error *ngIf="subCategoryForm.get('name')?.hasError('required')">
                        {{ 'REQUIRED.NAME' | translate }}
                    </mat-error>
                     <mat-error *ngIf="subCategoryForm.get('name')?.hasError('maxlength')">
                        {{ 'REQUIRED.MAXIMUM100' | translate }}
                    </mat-error>
                </mat-form-field>

            </div>
            <div class="col-lg-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'ENTITY.CATEGORY' | translate }}</mat-label>
                    <mat-select formControlName="categoryId">
                        @for (category of categoryList; track category) {
                        <mat-option [value]="category.id">{{category.name}}</mat-option>
                        }
                    </mat-select>
                    <mat-error *ngIf="subCategoryForm.get('categoryId')?.hasError('required')">
                        {{ 'REQUIRED.SELECTED_VALUE' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>

        </div>

        <div class="row">

            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.DESCRIPTION_LABEL' | translate }}</mat-label>
                    <textarea matInput placeholder="{{ 'LABEL.DESCRIPTION_LABEL' | translate }}" cols="5" rows="3"
                        formControlName="description"></textarea>
                         <mat-error *ngIf="subCategoryForm.get('description')?.hasError('maxlength')">
                        {{ 'REQUIRED.MAXIMUM255' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>

        </div>

        <div class="row m-t-20">
            <div class="col-lg-9"></div>
            <div class="col-lg-3 d-flex justify-content-end">
                <button mat-stroked-button (click)="onCloseDialog()" class="m-r-5">{{ 'BUTTON.BTN_CLOSE' | translate }}</button>
                <button mat-flat-button color="primary" class="m-l-4" (click)="onSubcategorySave()" *ngIf="!isEdit"
                    [disabled]="subCategoryForm.invalid">
                    {{ 'BUTTON.BTN_SAVE' | translate }}</button>
                <button mat-flat-button color="primary" *ngIf="isEdit" (click)="onSubcategoryUpdate()" class="m-l-4"
                    [disabled]="subCategoryForm.invalid">
                    {{ 'BUTTON.BTN_SAVE' | translate }}</button>
            </div>

        </div>
    </form>
</div>